import { t } from '../i18n';
import { DatabaseRuleError } from './api';

/** A rule the database (or its shared Zod mirror) refused, in words; anything else is a retry. */
export function errorText(error: unknown): string {
  if (error instanceof DatabaseRuleError) return t(`dbError.${error.hint}`);
  return t('place.saveError');
}
